import { Sender } from 'xstate';

import asyncCallback from '@/framework/logic/utils/asyncCallback';
import { LogicContext } from '@/logic/main/types';
import { SOCKET_ID } from '@/model/promotions';

export const waitForPromotionsModal = (context: LogicContext) =>
  asyncCallback(
    async (
      callback: Sender<{
        type: 'MODAL_TIMEOUT' | 'MODAL_LOADED';
      }>
    ) => {
      if (document.getElementById(SOCKET_ID)) return callback('MODAL_LOADED');
      const targetNode = document.getElementById('lobby-root');
      if (!targetNode) return callback('MODAL_TIMEOUT');
      const config = { attributes: false, childList: true, subtree: true };

      const mutationCallback = (mutationList: MutationRecord[]) => {
        mutationList.forEach(mutation => {
          if (document.getElementById(SOCKET_ID)) {
            observer.disconnect();
            return callback('MODAL_LOADED');
          }
        });
      };

      const observer = new MutationObserver(mutationCallback);
      observer.observe(targetNode, config);

      const timeoutId = setTimeout(() => {
        observer.disconnect();
        return callback('MODAL_TIMEOUT');
      }, 1000);

      return () => {
        clearTimeout(timeoutId);
      };
    }
  );
